export default __webpack_public_path__ + "static/media/3-2-1.91896285.webp";